var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/google_play_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33491 4L12.9679 11.4833L15.0606 9.41672L5.80853 4.1414C5.65433 4.05303 5.48911 4.00408 5.33491 4ZM4.69608 4.34806C4.62724 4.46907 4.58594 4.61183 4.58594 4.77226V19.3148C4.58594 19.4317 4.61072 19.5364 4.65202 19.6302L12.4612 11.9728L4.69608 4.34806ZM15.6994 9.77566L13.4635 11.9728L15.6994 14.1591L18.431 12.6145C18.8192 12.3929 18.8743 12.1115 18.8716 11.9619C18.8674 11.7145 18.7091 11.4833 18.442 11.3419C18.2093 11.2182 16.4814 10.2243 15.6994 9.77566ZM12.9679 12.4623L5.26883 20C5.39687 19.9932 5.53593 19.966 5.66534 19.8912C5.96686 19.7186 12.0647 16.2366 12.0647 16.2366L15.0716 14.5289L12.9679 12.4623Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayFilled);
export default __webpack_public_path__ + "static/media/google_play_filled.5a7f8a3fbc4871de1c407fd978dbd1f2.svg";
export { ForwardRef as ReactComponent };